define(function(require, exports, module) {
    function Drag(el, parent) {
        this.el = el
        this.parent = parent
        this.drag = false
        this.iX = 0
        this.iY = 0
    }
    Drag.prototype.init = function() {
        var _this = this
        this.el.on('mousedown', function(e) {
            _this.drag = true
            var e = e || window.event
            _this.iX = e.clientX - _this.parent.offset().left
            _this.iY = e.clientY - _this.parent.offset().top
            e.cancelBubble = true
        })
        $(document).on('mousemove', function(e) {
            if (_this.drag) {
                var e = e || window.event
                var oX = e.clientX - _this.iX
                var oY = e.clientY - _this.iY - $(window).scrollTop()
                if (oX < 0) {
                    oX = 0
                } else if (
                    oX >
                    $(document.body).width() - _this.parent.outerWidth(true)
                ) {
                    oX =
                        $(document.body).width() - _this.parent.outerWidth(true)
                }
                if (oY < 0) {
                    oY = 0
                } else if (
                    oY >
                    $(document.body).height() - _this.parent.outerHeight(true)
                ) {
                    oY =
                        $(document.body).height() -
                        _this.parent.outerHeight(true)
                }
                _this.parent.css({
                    left: oX + 'px',
                    top: oY + 'px',
                    'margin-left': '0px',
                    'margin-top': '0px'
                })
                return false
            }
        })
        $(document).on('mouseup', function(e) {
            _this.drag = false
            e.cancelBubble = true
            return false
        })
    }

    function popup(option) {
        this.drag = false
        this.id = option.id
        this.width = option.width || 500
        this.height = option.height || 180
        this.top = option.top || '35%'
        this.okCallback = option.okCallback
        this.cancleCallback = option.cancleCallback
        this.ele = $(this.id)
        this.ele.width(this.width)
        this.ele.height(this.height)
        this.ele.css({
            'margin-left': -this.width / 2 + 'px',
            'margin-top': -this.height / 2 + 'px',
            top: this.top
        })
        var title = this.ele.find('.pop-title')
        var okBtn = this.ele.find('.sure')
        var cancleBtn = this.ele.find('.cancle')
        var deleteBtn = this.ele.find('.pop-delete')
        var _this = this
        // title.on('mousedown', function(e) {
        //     _this.drag = true;
        //     var e = e || window.event;
        //     iX = e.clientX - _this.ele.offset().left;
        //     iY = e.clientY - _this.ele.offset().top;
        //     e.cancelBubble = true;
        // });
        // $(document).on('mousemove', function(e) {
        //     if(_this.drag) {
        //         var e = e || window.event;
        //         var oX = e.clientX - iX;
        //         var oY = e.clientY - iY - $(window).scrollTop();
        //         if(oX < 0){
        //             oX = 0;
        //         }
        //         else if(oX > $(document.body).width()-_this.ele.outerWidth(true)){
        //             oX = $(document.body).width()-_this.ele.outerWidth(true);
        //         }
        //         if(oY < 0){
        //             oY = 0;
        //         }
        //         else if(oY > $(document.body).height()-_this.ele.outerHeight(true)){
        //             oY = $(document.body).height()-_this.ele.outerHeight(true);
        //         }
        //         _this.ele.css({'left':oX + 'px', 'top':oY + 'px','margin-left':'0px','margin-top':'0px'});
        //         return false;
        //     }
        // });
        // $(document).on('mouseup', function(e) {
        //     _this.drag = false;
        //     e.cancelBubble = true;
        //     return false;
        // });
        okBtn.on('click', function() {
            _this.okCallback && _this.okCallback()
            _this.ele.parent('.qz-mask').removeClass('show')
        })
        cancleBtn.on('click', function() {
            _this.cancleCallback && this.cancleCallback()
            _this.ele.parent('.qz-mask').removeClass('show')
        })
        deleteBtn.on('click', function() {
            _this.cancleCallback && this.cancleCallback()
            _this.ele.parent('.qz-mask').removeClass('show')
        })

        var d = new Drag(title, _this.ele)
        d.init()
    }
    popup.prototype.show = function() {
        this.ele.parent('.qz-mask').addClass('show')
    }

    popup.prototype.hide = function() {
        this.ele.parent('.qz-mask').removeClass('show')
    }
    popup.prototype.okCallback = function() {
        this.okCallback && this.okCallback()
        this.ele.parent('.qz-mask').removeClass('show')
    }
    popup.prototype.cancleCallback = function() {
        this.cancleCallback && this.cancleCallback()
        this.ele.parent('.qz-mask').removeClass('show')
    }

    // alert组件
    var alertTpl = [
        '<div id="pop-alert" class="qz-mask">',
        '<div class="qz-mask-background"></div>',
        '<div class="qz-pop">',
        '<div class="pop-title no-border">',
        '<span>提示</span><i class="iconfont pop-delete">&#xe618;</i>',
        '</div>',
        '<div class="pop-content">',
        '<div class="pop-label line">',
        '<i class="iconfont icon-alert mr5">&#xe64f;</i>',
        '<span class="pop-label-content"></span>',
        '</div>',
        '</div>',
        '<div class="pop-buttons no-border">',
        '<button class=" ok small mr10">确定</button>',
        '</div>',
        '</div>',
        '</div>'
    ].join('')

    function alert(msg, okCallback) {
        var popAlert = $('#pop-alert')
        if (popAlert.length <= 0) {
            $(document.body).append(alertTpl)
            popAlert = $('#pop-alert')

            popAlert.find('.ok').on('click', function() {
                removeCallbackFn()
            })
            popAlert.find('.pop-delete').on('click', function() {
                removeCallbackFn()
            })
            var d = new Drag(
                popAlert.find('.pop-title'),
                popAlert.find('.mall-pop')
            )
            d.init()
        }

        popAlert.find('.pop-label-content').html(msg)
        popAlert.addClass('show')

        var removeCallbackFn = function() {
            okCallback && okCallback()
            popAlert.remove()
        }
    }

    // confrim 组件
    var confirmtTpl = [
        '<div id="pop-confirm" class="qz-mask">',
        '<div class="qz-mask-background"></div>',
        '<div class="qz-pop">',
        '<div class="pop-title no-border">',
        '<span>确认</span><i class="iconfont pop-delete">&#xe618;</i>',
        '</div>',
        '<div class="pop-content">',
        '<div class="pop-label line">',
        '<i class="iconfont icon-confirm mr5">&#xe63a;</i>',
        '<span class="pop-label-content"></span>',
        '</div>',
        '</div>',
        '<div class="pop-buttons no-border">',
        '<button class=" ok small mr10">确定</button>',
        '<button class=" cancel small mr10">取消</button>',
        '</div>',
        '</div>',
        '</div>'
    ].join('')

    function confirm(msg, okCallback, cancelCancel) {
        var popConfirm = $('#pop-confirm')
        if (popConfirm.length <= 0) {
            $(document.body).append(confirmtTpl)
            popConfirm = $('#pop-confirm')

            popConfirm.find('.ok').on('click', function() {
                okCallbackFn()
            })
            popConfirm.find('.pop-delete').on('click', function() {
                removeCallbackFn()
            })
            popConfirm.find('.cancel').on('click', function() {
                removeCallbackFn()
            })

            var d = new Drag(
                popConfirm.find('.pop-title'),
                popConfirm.find('.mall-pop')
            )
            d.init()
        }

        popConfirm.find('.pop-label-content').html(msg)
        popConfirm.addClass('show')

        var removeCallbackFn = function() {
            cancelCancel && cancelCancel()
            popConfirm.remove()
        }

        var okCallbackFn = function() {
            okCallback && okCallback()
            popConfirm.remove()
        }
    }

    return {
        init: function() {
            return {
                initPop: popup
            }
        },
        alert: alert,
        confirm: confirm
    }
})
